import { initializeApp } from 'firebase/app';
import { getAnalytics, logEvent, setUserProperties, setUserId } from 'firebase/analytics';
import history from '../browserHistory';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

const firebaseConfig = {
  apiKey: 'AIzaSyAXSfFyI86qUrkMN-YfzIUrqlZoyo13LkU',
  authDomain: 'dental-portal-2939f.firebaseapp.com',
  projectId: 'dental-portal-2939f',
  storageBucket: 'dental-portal-2939f.firebasestorage.app',
  messagingSenderId: '876996125452',
  appId: '1:876996125452:web:19b1d47d2ec8528c361f29',
  measurementId: 'G-K74X1TY5NV',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig, 'analytics');
const analytics = getAnalytics(app);

export const logCustomEvent = async (eventName, eventParams) => {
  if (import.meta.env.VITE_TEMP_MEE_ENV === 'production') {
    await logEvent(analytics, 'page_view', {
      page_location: history.location.pathname,
      page_path: history.location.pathname,
      page_title: history.location.pathname,
    });
    await logEvent(analytics, eventName, eventParams);
  }
};

export const custoSetUserProperties = async (user) => {
  if (import.meta.env.VITE_TEMP_MEE_ENV === 'production') {
    const data = {
      name: `${user?.first_name || ''} ${user?.last_name}`,
      email: user?.email_id || '',
      phone_number: user?.contact_number,
      office: user?.office_name,
    };
    await setUserId(analytics, user?.id);

    await setUserProperties(analytics, data);
  }
};
